import { Component, OnInit, ViewContainerRef, QueryList, ViewChildren, ComponentFactoryResolver, EventEmitter, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from '@services/api/api.service';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BreadCrumbsService } from '@services/NewFolder/bread-crumbs.service';
import { SplitAreaDirective } from 'angular-split';
import { DialogService } from 'primeng/api';
import { MfChromeSupportComponent } from '../mf-chrome-support/mf-chrome-support.component';
export interface IBladeForm {
  displayName: string ;
  component: any;
  index: number;
  width?: number;
  hideClose?: boolean;
  showOnlyIfIdInUrl?: boolean;
  originalWidth?: number;
  autoMinimise?: boolean;
  minimiseWhenLowerThanIndex?: number;
}

@Component({
  selector: 'app-mf-blade-forms',
  templateUrl: './mf-blade-forms.component.html',
  styleUrls: ['./mf-blade-forms.component.css'],
})
export class MfBladeFormsComponent implements OnInit {
  private formInstances: Array<any>;
  public hideForms: boolean = true;
  public saving: boolean;
  public loading: boolean;
  private _subscriptions: Array<Subscription> = new Array<Subscription>();
  public get CurrentIndex() {
    return this.currentIndex;
  }
  public set CurrentIndex(value) {
    this.currentIndex = value;
    var _th = this;
    this.calcedSize = this.calcSize();
    this.minimiseExpandForms();

    setTimeout(function () {
      _th.test.nativeElement.scrollTo({ left: (_th.test.nativeElement.scrollWidth) });
      if (value == 0)
        setTimeout(function () {
          return _th.card.nativeElement.width + 'px';
        }, 100)
    }, 1)

  }
  public currentIndex: number = 0;
  private _currentRouteParams: any;
  public get currentRouteParams() {
    return this._currentRouteParams;
  }
  public set currentRouteParams(value) {
    this._currentRouteParams = value;
    this.currentRouteParamsChange.emit(value);
  }
  public currentRouteParamsChange = new EventEmitter();
  public saveClicked = new EventEmitter();
  public saveFinished = new EventEmitter();
  protected forms: Array<IBladeForm>;
  public canAddNew: boolean = false;
  public canSave: boolean = false;
  public calcedSize: any;
  public calcSize() {
    var _th = this;
    if (this.currentIndex == 0) {
      return '100%';
    }
    var currentlyVisible = this.formsToBuild.filter(function (o) {
      return _th.isBladeVisible(o)
    });
    var width = 0;
    currentlyVisible.forEach(o => {
      width += o.width
    });
    if (width < this.test.nativeElement.scrollWidth)
      width = this.test.nativeElement.scrollWidth;
    return width + 'px';
  }

  public minimiseExpandForms() {
    var _th = this;
    if (!_th.formInstances)
      return;
    var formsToMinimise = this.formsToBuild.filter(function (o) {
      if ((typeof o.autoMinimise == 'undefined' || o.autoMinimise) && o.index < _th.currentIndex)
        return true;
      if (o.minimiseWhenLowerThanIndex < _th.currentIndex)
        return true;

      return false;
    });
    formsToMinimise.forEach(o => {
      _th.formInstances[o.index].minimise();
      _th.minimiseForm(o.index);
    })

    var formsToExpand = this.formsToBuild.filter(function (o) {
      if (o.minimiseWhenLowerThanIndex >= _th.currentIndex)
        return true;

      return false;
    });
    formsToExpand.forEach(o => {
      _th.formInstances[o.index].expandForm();
      _th.expandForm(o.index);
    })

    this.formInstances[_th.currentIndex].expandForm();
    var size = this.calcSizeNum();
    if (isNaN(size))
      this.calcedSize = '100%'
    else
      this.calcedSize = size + 'px';
    if (this.currentIndex == 0)
      this.calcedSize = this.calcSize();
  }
  public calcSizeNum() {
    var _th = this;
    var currentlyVisible = this.formsToBuild.filter(function (o) {
      return _th.isBladeVisible(o)
    });
    var width = 0;
    currentlyVisible.forEach(o => {
      width += o.width
    });
    return width;
  }

  //public get formsToBuild(): Array<IBladeForm> { return this.forms };
  public formsToBuild: Array<IBladeForm>

  @ViewChild('card', { static: true }) public card: ElementRef<any>;
  @ViewChild('breadCrumbActions', { static: true }) public breadCrumbActions: ViewContainerRef;
  @ViewChild('scrollContainer', { static: true }) public scrollContainer: ElementRef<any>;
  @ViewChild('test', { static: true }) public test: ElementRef<any>;


  @ViewChildren('formDetails', { read: ViewContainerRef }) public formDetails: QueryList<ViewContainerRef>;
  @ViewChildren('splitArea', { read: ViewContainerRef }) public splitArea: QueryList<SplitAreaDirective>;
  constructor(private ApiService: ApiService,
    private authService: IdentityAuthService,
    private router: Router,
    private route: ActivatedRoute,
    private componentFactoryResolver: ComponentFactoryResolver,
    private breadCrumbService: BreadCrumbsService) {
    this.breadCrumbService.onNavigateBack.subscribe(() => {
      this.navigateBackNested()
    });
  }

  ngOnInit() {
    this.formsToBuild = this.forms;
    this.formsToBuild.forEach(o => {
      o.originalWidth = o.width
    })
    this._subscriptions.push(
      this.route.params.subscribe(
        params => {
          this.currentRouteParams = params;
          let maxIndex = 0;
          Object.keys(this.currentRouteParams).forEach(key => {
            if (key.indexOf("id_") != -1) {
              let idIndex = parseInt(key.substring(3, key.length));
              if (idIndex > maxIndex)
                maxIndex = idIndex;
            }
          });
          this.CurrentIndex = maxIndex;
          this.buildBreadCrumbs();
        }
      )
    );
  }

  public minimiseForm(formIndex) {
    this.forms[formIndex].width = 40;
    this.calcedSize = this.calcSizeNum() + 'px';
  }

  public expandForm(formIndex) {
    this.forms[formIndex].width = this.forms[formIndex].originalWidth;
    var size = this.calcSizeNum();
    if (isNaN(size))
      this.calcedSize = '100%'
    else this.calcedSize = this.calcSizeNum() + 'px';
  }


  public ngAfterViewInit() {
    if (this.formDetails && this.formDetails.length > 0) {
      this.buildForms();
      this.minimiseExpandForms();
    }
  }

  public addNewItem() {
    this.navigateNextNested(null);
  }


  private buildBreadCrumbs() {
    var self = this;
    this.breadCrumbService.breadcrumbs = new Array();
    this.formsToBuild.forEach(form => {
      if (this.isBladeVisible(form))
        this.breadCrumbService.breadcrumbs.push({
          id: form.index,
          label: form.displayName, command: function () {
            self.navigateBackToIndex(form.index + 1)
          }
        });
    })

  }

  private buildForms() {
    this.formInstances = new Array();
    for (let i = 0; i < this.formDetails.toArray().length; i++) {
      let component = this.formsToBuild[i];
      if (component) {
        let target = this.formDetails.toArray()[i];
        let widgetComponent = this.componentFactoryResolver.resolveComponentFactory(component.component);
        let componentRef: any = target.createComponent(widgetComponent);
        let _component: any = (componentRef.instance);
        _component.entity = component.component;
        _component.entity.component = _component;
        _component.parent = this;
        _component.formIndex = component.index;

        _component.displayName = component.displayName;
        _component.hideClose = component.hideClose;
         
        //_component.splitter = this.splitArea.toArray()[component.index].element;
        this.formInstances.push(_component);
      }
    }
  }


  public navigateNextNested(id) {
    this.CurrentIndex += 1;
    let newRouteParams: any = {};
    Object.assign(newRouteParams, this.currentRouteParams);
    newRouteParams["id_" + this.CurrentIndex] = id;
    var originalRoute = this.router.url
    if (originalRoute.indexOf(';') != -1) //strip out existing params
      originalRoute = originalRoute.substring(0, this.router.url.indexOf(';'));
    this.router.navigate([originalRoute, newRouteParams]);
  }

  public navigateBackNested() {
    let newRouteParams: any = {};
    Object.assign(newRouteParams, this.currentRouteParams);
    delete newRouteParams["id_" + this.CurrentIndex];
    this.CurrentIndex -= 1;
    var originalRoute = this.router.url
    if (originalRoute.indexOf(';') != -1) //strip out existing params
      originalRoute = originalRoute.substring(0, this.router.url.indexOf(';'));
    this.router.navigate([originalRoute, newRouteParams]);
  }

  public navigateBackToIndex(curIndex) {
    let newRouteParams: any = {};
    Object.assign(newRouteParams, this.currentRouteParams);
    while (curIndex <= this.CurrentIndex) {
      delete newRouteParams["id_" + this.CurrentIndex];
      this.CurrentIndex -= 1;
    }
    var originalRoute = this.router.url
    if (originalRoute.indexOf(';') != -1) //strip out existing params
      originalRoute = originalRoute.substring(0, this.router.url.indexOf(';'));
    this.router.navigate([originalRoute, newRouteParams]);
  }

  public navigateToIndex(newIndex, newId, startNavIndex?) {
    let newRouteParams: any = {};
    Object.assign(newRouteParams, this.currentRouteParams);

    while (startNavIndex < this.currentIndex) {
      delete newRouteParams["id_" + this.currentIndex];
      this.CurrentIndex -= 1;
    }

    while (newIndex < this.currentIndex) {
      delete newRouteParams["id_" + this.currentIndex];
      this.CurrentIndex -= 1;
    }
    this.CurrentIndex = newIndex;
    newRouteParams["id_" + this.currentIndex] = newId;
    var originalRoute = this.router.url
    if (originalRoute.indexOf(';') != -1) //strip out existing params
      originalRoute = originalRoute.substring(0, this.router.url.indexOf(';'));
    this.router.navigate([originalRoute, newRouteParams]);
  }

  public navigateHome() {
    this.router.navigate(['/']);
  }

  private saveItem() {
    this.saveClicked.emit();
  }

  public isBladeVisible(form: IBladeForm) {
    if (form.showOnlyIfIdInUrl) {
      let isVisible = false;
      Object.keys(this.currentRouteParams).forEach(key => {
        if (key.indexOf("id_" + form.index) != -1) {
          isVisible = true;
        }
      });
      return isVisible;
    }
    if (this.currentRouteParams)

      return form.index <= this.currentIndex;


  }

  public getBladeByIndex(index: number) {
    return this.formInstances[index];
  }
}
